module.exports = __webpack_public_path__ + "static/media/hexagonalPyramid.fd66b25c.svg";